<template lang='pug'>
div(:class='$style[`cc-search-result-container`]')
  div(v-if='onSearch' :class='$style[`cc-search-loader`]')
    IconLoading( :size='28' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-search-result-wrap`]')
    div(v-if='passData.article.total || passData.scoop.total || passData.qa.total || passData.resume.total || passData.drug.total' :class='$style[`cc-search-result-list`]')
      //- Search tag result
      div(:class='$style[`cc-search-result-topic`]') 相關資料

      //- 搜尋文章結果
      router-link(
        v-show='passData.scoop.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `scoop` }}')
        figure.toggle-icon.toggle-icon-scoop.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 精選文章
          span(:class='$style[`cc-search-result-status`]') {{ `共 ${passData.scoop.total} 篇` }}

      //- 搜尋文章結果
      router-link(
        v-show='passData.article.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `article` }}')
        figure.toggle-icon.toggle-icon-article.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 網路文章
          span(:class='$style[`cc-search-result-status`]') {{ `共 ${passData.article.total} 篇` }}

      //- 搜尋討論板結果
      router-link(
        v-show='passData.qa.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `qa` }}')

        figure.toggle-icon.toggle-icon-qa.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 癌症討論板
          span(:class='$style[`cc-search-result-status`]') {{ `共 ${passData.qa.total} 則` }}

      //- 搜尋抗癌故事結果
      router-link(
        v-show='passData.resume.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `resume` }}')

        figure.toggle-icon.toggle-icon-resume.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 癌友故事卡
          span(:class='$style[`cc-search-result-status`]') {{ `共 ${passData.resume.total} 則` }}

      //- 搜尋治療藥物結果
      router-link(
        v-show='passData.drug.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `drug` }}')

        figure.toggle-icon.toggle-icon-drug.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 治療藥物
          span(:class='$style[`cc-search-result-status`]') {{ `共 ${passData.drug.total} 種` }}


    div(v-if='passData.doctor.total' :class='$style[`cc-search-result-list`]')
      //- Search Person result
      div(:class='$style[`cc-search-result-topic`]') 相關醫生

      //- 搜尋主治醫師結果
      router-link(
        v-show='passData.doctor.total'
        role='button'
        tabindex='0'
        aria-label='查看結果'
        :class='[$style[`cc-search-result-nav`], $style[`cc-search-result-tag`]]'
        :to='{ name: `search-result`, params: { keyword: passInputValue, searchType: `doctor` }}')

        figure.toggle-icon.toggle-icon-doctor.size-big.default-color(:class='$style[`cc-search-result-tb`]')
        div(:class='$style[`cc-search-result-sub-content`]')
          span(:class='$style[`cc-search-result-keyword`]') 醫護會員
          span(class='$style[`cc-search-result-status`]') {{ `共 ${passData.doctor.total} 位` }}

  div(
    v-if='!onSearch && !passData.article.total && !passData.scoop.total && !passData.qa.total && !passData.resume.total && !passData.drug.total && !passData.doctor.total'
    :class='$style[`cc-search-noResult`]')
    figure.toggle-icon.toggle-icon-warn.size-big.default-color(:class='$style[`cc-search-result-tb`]')
    span 查無結果


</template>

<script>
import IconLoading from '../../icon/Loading';
// import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    IconLoading,
  },

  props: {
    onSearch: {
      type: Boolean,
      default: false,
    },
    passData: {
      type: Object,
      required: true,
      default: null,
    },
    passInputValue: {
      type: String,
      required: true,
      default: '',
    },
  },

  // mounted() {
  // },

  // data() {
  //   return {
  //   }
  // }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/topbar/boardSearch.scss';
</style>
